<template>
  <AddAgencyForm
    title="Configure your agency"
    :showPrefixField="true"
    submitUrl="/api/register/set-up-agency-atlassian"
    :onSuccessfulSubmit="handleSuccessfulSubmit"
  >
    <template #progress-bar>
      <CompleteSignupProgressAtlassian :currentStep="1" />
    </template>
  </AddAgencyForm>
</template>

<script>
import { isConfirmTokenPresent, showSessionExpiredWarning } from '@utils/confirmationToken'
import AddAgencyForm from '@components/sign-up/AddAgencyForm.vue'
import CompleteSignupProgressAtlassian from '@components/sign-up/complete-signup-progress/CompleteSignupProgressAtlassian.vue'

export default {
  name: 'AddAgencyAtlassian',
  components: { CompleteSignupProgressAtlassian, AddAgencyForm },
  mounted () {
    // Show warning message on page load if no confirmation cookie
    if (!isConfirmTokenPresent(this.$cookies)) {
      showSessionExpiredWarning(this)
    }
  },
  methods: {
    handleSuccessfulSubmit () {
      this.$router.replace({ name: this.ROUTES.INVITE_TEAMMATES_ATLASSIAN.name })
    }
  }
}
</script>
